<template>

    <div class="page p-event_edit">
        <the-dashboard-heading :back-href="{ name: 'PatientShow', params: { id: patient.id } }">
            <h2>
                <router-link :to="{ name: 'Patients' }">Pacjenci</router-link>
                <router-link :to="{ name: 'PatientShow', params: { id: patient.id } }">{{ patientName }}</router-link>
                <span>Edycja planowanej wizyty</span>
            </h2>
        </the-dashboard-heading>
        <the-dashboard-content>
            <event-calendar
                class="p-event_edit__calendar"
                v-model="event">
            </event-calendar>
            <event-form
                class="p-event_edit__form"
                v-model="event"
                @submit="updateEvent"
                mode="edit">
            </event-form>
        </the-dashboard-content>

        <v-calendar-legend></v-calendar-legend>
    </div>

</template>


<script>

import moment from 'moment'
import {mapGetters} from 'vuex'
import store from 'Store'
import {ErrorBag} from 'vee-validate'
import TheDashboardHeading from 'Components/Dashboard/TheDashboardHeading'
import TheDashboardContent from 'Components/Dashboard/TheDashboardContent'
import VCalendarLegend from 'Components/VCalendarLegend'

import EventForm from 'Components/Event/EventForm'
import EventCalendar from 'Components/Event/EventCalendar'

export default {

    name: 'ViewPatientEventEdit',

    computed: {
        ...mapGetters(['patient', 'event']),

        patientName() {
            let name = this.patient.first_name + ' ' + this.patient.last_name
            return name.trim()
        },
    },

    methods: {
        updateEvent(_event, afterSubmit) {
            _event.id = this.event.id

            this.$store.dispatch('EVENT_UPDATE', _event).then(() => {
                afterSubmit()
                this.$router.push({name: 'PatientShow', params: {id: this.patient.id}})
            }).catch((error) => {
                afterSubmit()
                this.$alert.error('Planowana wizyta', error.response.data.message)
            })
        },
    },

    beforeRouteEnter(to, from, next) {
        store.dispatch('PAGE_LOADING_SET')
        Promise.all([
            store.dispatch('EVENT_FETCH', {
                id: to.params.eventId,
                query: {with: 'patient'}
            }),
            store.dispatch('PATIENT_FETCH', to.params.id),
            store.dispatch('PHT_OFFICES_FETCH', to.params.id)
        ]).then(() => {
            store.dispatch('PAGE_LOADING_RESET')
            next()
        })
    },

    components: {
        TheDashboardHeading,
        TheDashboardContent,
        EventForm,
        EventCalendar,
        VCalendarLegend
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.p-event_edit {
    padding-bottom: 0;

    &__calendar {
        width: 450px;

        @include bp($screen-xl) {
            order: 2;
            width: 100%;
        }
    }
    &__form {
        width: calc(100% - 450px);

        @include bp($screen-xl) {
            order: 1;
            width: 100%;
        }
    }
}

</style>
